import KeyboardDoubleArrowLeft from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRight from "@mui/icons-material/KeyboardDoubleArrowRight";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useNavigationCollapse } from "../context/NavigationContext";

/**
 * Floating button to toggle navigation collapse state
 * Positioned at the bottom of the navigation
 */
const CollapseButton = () => {
    const { t } = useTranslation();
    const { isCollapsed, toggleCollapsed } = useNavigationCollapse();

    const tooltipText = isCollapsed ? t("NavigationBar.ExpandNavigation") : t("NavigationBar.CollapseNavigation");

    return (
        <Tooltip title={tooltipText} placement="right" arrow>
            <IconButton onClick={toggleCollapsed} className="navigation-collapse-btn" size="small">
                {isCollapsed ? (
                    <KeyboardDoubleArrowRight fontSize="small" />
                ) : (
                    <KeyboardDoubleArrowLeft fontSize="small" />
                )}
            </IconButton>
        </Tooltip>
    );
};

export default CollapseButton;
